import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { poetasSelector, fetchPoetas, updatePoeta, addPoeta } from 'slices/poetaSlice';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { Modal } from 'reactstrap';

const PoetaForm = ({ item, handleClose, callback }) => {
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState({
        project: '',
        task: '',
        expense_type_account: '',
        org: '',
        award: ''
    });

    const { error, loader } = useSelector(poetasSelector);

    // Populate form when editing
    useEffect(() => {
        if (item?.id) {
            setFormValues({
                project: item?.project || "",
                task: item?.task || "",
                expense_type_account: item?.expense_type_account || "",
                org: item?.org || "",
                award: item?.award || ""
            });
        }

        return () => {
            setFormValues({
                project: '',
                task: '',
                expense_type_account: '',
                org: '',
                award: ''
            });
        };
    }, [item]);

    // Handle input change
    const handleChange = (e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    };

    // Callback after API call
    const submitCallback = (status, message) => {
        if (status) {
            callback();
            toast.success(message, { className: "successToast" });
            dispatch(fetchPoetas());
            handleClose();
        } else {
            toast.error(message, { className: "errorToast" });
        }
    };

    // Submit form
    const handleSubmit = (event) => {
        event.preventDefault();
        if (item?.id) {
            dispatch(updatePoeta(formValues, item?.id, submitCallback));
        } else {
            dispatch(addPoeta(formValues, submitCallback));
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="row-primary">
                <h2>Project *</h2>
                <input
                    onChange={handleChange}
                    required
                    name="project"
                    className="input-in type_inp"
                    type="text"
                    placeholder="Project"
                    value={formValues.project}
                />
            </div>
            <div className="row-primary">
                <h2>Task *</h2>
                <input
                    onChange={handleChange}
                    required
                    name="task"
                    className="input-in type_inp"
                    type="number"
                    placeholder="Task"
                    value={formValues.task}
                />
            </div>

            <div className="row-primary">
                <h2>Expense Type Account *</h2>
                <input
                    onChange={handleChange}
                    required
                    name="expense_type_account"
                    className="input-in type_inp"
                    type="text"
                    placeholder="Expense Type Account"
                    value={formValues.expense_type_account}
                />
            </div>

            <div className="row-primary">
                <h2>Org *</h2>
                <input
                    onChange={handleChange}
                    required
                    name="org"
                    className="input-in type_inp"
                    type="text"
                    placeholder="Org"
                    value={formValues.org}
                />
            </div>

            <div className="row-primary">
                <h2>Award</h2>
                <input
                    onChange={handleChange}
                    name="award"
                    className="input-in type_inp"
                    type="text"
                    placeholder="Award"
                    value={formValues.award}
                />
            </div>

            {error?.errors &&
                Object.keys(error.errors).map((key) =>
                    error.errors[key].map((errMsg, i) => (
                        <div key={i} style={{ marginBottom: 10 }}>
                            <ErrorMessage text={errMsg} />
                        </div>
                    ))
                )}

            <div className="Form-footer">
                <button type="button" className="Cancle_button" onClick={handleClose}>
                    Cancel
                </button>
                <SubmitButton btnText={item?.id ? "Update" : "Create"} loader={loader} />
            </div>
        </form>
    );
};

const AddPoeta = ({ show, item, onClose, callback }) => {
    return (
        <Modal isOpen={show} toggle={onClose} centered className="modal-medium">
            <div className="modal-content full_modal">
                <div className="modal-header header_modal align-items-center">
                    <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Poeta</h5>
                    <button type="button" className="btn-close" onClick={onClose}></button>
                </div>
                <div className="modal-body modal_form_body">
                    <PoetaForm item={item} handleClose={onClose} callback={callback} />
                </div>
            </div>
        </Modal>
    );
};

export default AddPoeta;
